__turbopack_context__.v({
  "chip": "chip-module__5ioxNa__chip",
  "flag": "chip-module__5ioxNa__flag",
  "risk": "chip-module__5ioxNa__risk",
  "sm": "chip-module__5ioxNa__sm",
});
